import { HubSpotForm, JoinFormType, PackagePrices } from 'types/join';

export const formatPlan = (plan: string) => {
  switch (plan.toLowerCase().replaceAll('_', '')) {
    case 'pricesheetmonthly':
      return 'Rapaport Plus';
    case 'pricesheetweekly':
      return 'Rapaport Basic';
    case 'rapaportplus':
      return 'Rapaport Plus';
    case 'rapaportbasic':
      return 'Rapaport Basic';
    case 'rapaportresearchreport':
      return 'Rapaport Research Report';
    case 'rapnetbuyerpro':
      return 'RapNet Buyer Pro';
    case 'rapnetbuyer':
      return 'RapNet Buyer';
    case 'rapnetdealer':
      return 'RapNet Dealer';
    case 'rapnetbuyerproindia':
      return 'RapNet Buyer Pro India';
    case 'rapnetbuyerindia':
      return 'RapNet Buyer India';
    case 'rapnetprimarysupplier':
      return 'RapNet Primary Supplier';
    default:
      return plan;
  }
};

type CreateHubSpotFormProps = {
  form: JoinFormType;
  selectedPlan: PackagePrices;
  sourcePage: string;
};
export const CreateHubSpotForm = ({
  selectedPlan,
  form,
  sourcePage
}: CreateHubSpotFormProps): HubSpotForm => {
  let isFromRapaport = false;
  if (sourcePage.includes('rapaport.com')) {
    isFromRapaport = true;
  }
  const hutk = document.cookie
    .split('; ')
    .find(row => row.startsWith('hubspotutk='))
    ?.split('=')[1];

  let leadsource = 'Website';
  let rapnetLeadSource = 'Marketing Website';
  let rapnetFormType = 'RapNet Registration Form';
  let rapnetLeadLocation = 'Membership Plans Page';
  if (isFromRapaport) {
    leadsource = 'Rapaport.com Registration Page';
    rapnetLeadSource = 'Rapaport';
    rapnetFormType = 'Rapaport Registration Form';
    rapnetLeadLocation = 'Rapaport.com Membership Plans Page';
  }
  const hbsptForm: HubSpotForm = {
    fields: [
      { name: 'firstname', value: form.firstName || '' },
      { name: 'lastname', value: form.lastName || '' },
      { name: 'email', value: form.email || '' },
      { name: 'sync_to_hubspot', value: false },
      { name: 'leadsource', value: leadsource },
      { name: 'rapnet_lead_source', value: rapnetLeadSource },
      { name: 'rapnet_form_type', value: rapnetFormType },
      { name: 'rapnet_lead_location', value: rapnetLeadLocation },
      { name: 'initial_plan_pick', value: formatPlan(form.initialPlan || '') },
      { name: 'requested_plan_pick', value: selectedPlan.packageName }
    ],
    context: {
      hutk: hutk || '',
      pageUri: window.location.href,
      pageName: document.title
    }
  };

  return hbsptForm;
};
